module.exports = __webpack_public_path__ + "static/media/booking.a97fbc78.jpg";